import React from "react";
import PresentationExcel from "./excel_reporting/PresentationExcel";
import PresentationDashboard from "./dashboard/PresentationDashboard";
import { Feature } from "feature";
import { useClientContext } from "contexts/client";

export default function MainDashboard() {
  const { state: clientState } = useClientContext();
  return (
    <div style={{ display: "flex" }}>
      <Feature name="dashboard">
        <div style={{ flexGrow: 4 }}>
          <PresentationDashboard
            client={clientState?.client?.name}
            deploy_target="main_dashboard"
          />
        </div>
      </Feature>

      <Feature name="excel">
        <div style={{ flexShrink: 3, maxWidth: 240 }}>
          <PresentationExcel client={clientState?.client?.name} deploy_target="main_dashboard" />
        </div>
      </Feature>
    </div>
  );
}
